import React, { useState, useEffect } from 'react';
import { FiShoppingBag, FiCheck, FiX } from 'react-icons/fi';
import { toast } from 'react-toastify';
import adminService from '../../services/admin.service';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const AdminStoresPage = () => {
  const [stores, setStores] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [page, setPage] = useState(1);

  const fetchStores = async () => {
    setLoading(true);
    try {
      const params = { page, limit: 20 };
      if (filter) params.approved = filter;
      const { data } = await adminService.getStores(params);
      setStores(data.data);
      setPagination(data.pagination);
    } catch (error) {
      console.error('Failed to fetch stores:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchStores(); }, [page, filter]);

  const handleApprove = async (storeId, approve) => {
    try {
      const { data } = await adminService.approveStore(storeId, approve);
      toast.success(data.message);
      fetchStores();
    } catch (error) {
      toast.error('Action failed');
    }
  };

  return (
    <div className="section-padding">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2><FiShoppingBag className="me-2" />Store Management</h2>
          <select
            className="form-select form-select-sm" style={{ width: 'auto' }}
            value={filter}
            onChange={(e) => { setFilter(e.target.value); setPage(1); }}
          >
            <option value="">All Stores</option>
            <option value="true">Approved</option>
            <option value="false">Pending</option>
          </select>
        </div>

        {loading ? <LoadingSpinner /> : (
          <>
            {stores.length > 0 ? (
              <div className="row g-3">
                {stores.map((store) => (
                  <div key={store._id} className="col-md-6 col-lg-4">
                    <div className="dashboard-card h-100">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h5 className="mb-0">{store.storeName}</h5>
                        <span className={`badge bg-${store.settings?.isApproved ? 'success' : 'warning'}`}>
                          {store.settings?.isApproved ? 'Approved' : 'Pending'}
                        </span>
                      </div>

                      {store.storeSlug && (
                        <p className="text-muted small mb-1">Slug: {store.storeSlug}</p>
                      )}
                      <p className="text-muted small mb-2">
                        Owner: {store.userId}
                      </p>

                      {store.description && (
                        <p className="small mb-3" style={{ maxHeight: '60px', overflow: 'hidden' }}>
                          {store.description}
                        </p>
                      )}

                      <p className="text-muted small mb-3">
                        Created: {new Date(store.createdAt).toLocaleDateString()}
                      </p>

                      <div className="d-flex gap-2">
                        {!store.settings?.isApproved ? (
                          <button
                            className="btn btn-sm btn-success flex-grow-1"
                            onClick={() => handleApprove(store._id, true)}
                          >
                            <FiCheck className="me-1" /> Approve
                          </button>
                        ) : (
                          <button
                            className="btn btn-sm btn-outline-danger flex-grow-1"
                            onClick={() => handleApprove(store._id, false)}
                          >
                            <FiX className="me-1" /> Revoke
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-5 text-muted">
                <FiShoppingBag size={48} className="mb-3" />
                <p>No stores found.</p>
              </div>
            )}

            {pagination.pages > 1 && (
              <nav className="d-flex justify-content-center mt-4">
                <ul className="pagination">
                  {Array.from({ length: pagination.pages }, (_, i) => (
                    <li key={i + 1} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setPage(i + 1)}>{i + 1}</button>
                    </li>
                  ))}
                </ul>
              </nav>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AdminStoresPage;
